import { Currency } from '@efex-components/common/Form/config';
import { Dialog, DialogContent, DialogTitle } from '@efexteam/components';
import { Box, Stepper, Step, StepLabel } from '@mui/material';
import useCurrencyBalance from '@main-hooks/useCurrencyBalance';
import { PayLendingModalProps } from '@pages/lending/types';
import { selectProfileData } from '@pages/profile/store/selectors';
import { formatCurrencyToNumber } from '@utils/formater';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import MethodValidation from './steps/MethodValidation';
import ResponseConfirmation from './steps/ResponseConfirmation';

const PayLendingModal = ({ open, onCancel }: PayLendingModalProps) => {
  const userProfile = useSelector(selectProfileData);

  const [step, setStep] = useState(0);

  const { bankAccount, company } = userProfile || {};
  const { accountCurrency } = company || {};
  const { currency } = bankAccount || {};

  const userCurrency = (accountCurrency || currency) as Currency;

  const { balance: currencyBalance } = useCurrencyBalance({
    currency: userCurrency || '',
  });

  if (!userCurrency) {
    return null;
  }

  return (
    <Dialog open={open} className="w-full" maxWidth="lg" onClick={onCancel}>
      <DialogTitle className="text-center" showCloseButton onClick={onCancel}>
        <Box sx={{ width: '100%', maxWidth: '200px', margin: '0 auto' }}>
          <Stepper activeStep={step}>
            <Step>
              <StepLabel />
            </Step>
            <Step>
              <StepLabel />
            </Step>
          </Stepper>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {step === 0 ? (
          <MethodValidation
            amount="100"
            currency="MXN"
            currencyBalance={currencyBalance}
            newAccountBalance={formatCurrencyToNumber(currencyBalance) - 100}
            setStep={setStep}
          />
        ) : null}
        {step === 1 ? (
          <ResponseConfirmation
            isSuccessful={false}
            lendingData={{
              amount: 100,
              currency: { name: 'MXN', id: 0, description: 'description' },
              settlementDate: new Date().toString(),
              documents: [],
              id: 0,
              efexAdvance: 0.19,
              enterpriseId: 0,
              isPayed: false,
              lendingRate: { id: 0, name: 'name', value: 0.19 },
              lendingType: { id: 0, name: 'name', description: 'description' },
              ownFunds: 0.19,
              percentagePayed: 0.19,
              provider: { id: 0, name: 'name', description: 'description' },
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default PayLendingModal;
